import { createRoot } from "react-dom/client";

import { App } from "@/core";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(rootElement);

void root.render(<App />);
